<template>
  <div class="dashboard-menu">
    <router-link to="/create-order" class="link">
      <div class="link-wrapper">
        <svg width="250" height="250" viewBox="0 0 250 250" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M242.877 96.8354L228.939 110.775L190.103 71.9431L204.047 58.0018C208.44 53.6089 215.04 53.0657 218.768 56.7891L244.09 82.116C247.812 85.838 247.27 92.4425 242.877 96.8354V96.8354ZM183.631 78.4119L222.467 117.248L129.861 209.853C129.436 210.277 128.257 211.457 126.603 211.878C126.411 211.971 126.215 212.049 126.022 212.11L77.6911 227.513C76.3386 227.94 74.9794 227.664 74.0977 226.781C73.2131 225.898 72.9394 224.54 73.3625 223.187L88.7651 174.861C88.8308 174.662 88.9093 174.47 88.9972 174.282C89.4208 172.625 90.5971 171.449 91.0263 171.021L108.43 153.618H49.6497C47.2802 153.618 45.3575 151.696 45.3575 149.326C45.3575 146.951 47.2798 145.034 49.6497 145.034H117.014L183.631 78.4119V78.4119ZM117.915 206.868L94.0081 182.965L87.595 203.096L97.785 213.287L117.915 206.868V206.868ZM182.139 93.8471C180.764 92.4709 178.534 92.4709 177.162 93.8471L104.968 166.037C103.594 167.412 103.594 169.642 104.968 171.017C106.341 172.391 108.572 172.391 109.946 171.017L182.139 98.8262C183.513 97.45 183.513 95.2205 182.139 93.8471V93.8471ZM177.776 231.283C177.776 233.862 175.678 235.964 173.098 235.964H87.9132L80.219 238.417C78.6735 238.909 77.0851 239.157 75.4952 239.157C72.1097 239.157 68.9621 237.998 66.3869 235.963H22.1657C19.5853 235.963 17.4811 233.867 17.4811 231.283V34.7121C17.4811 32.1318 19.5825 30.0317 22.1657 30.0317H39.7146V37.4423C39.7146 40.0255 41.809 42.1212 44.3964 42.1212C46.9829 42.1212 49.0772 40.0255 49.0772 37.4423V30.0313H75.9868V37.4418C75.9868 40.025 78.0812 42.1208 80.6677 42.1208C83.2551 42.1208 85.3494 40.025 85.3494 37.4418V30.0313H108.75V37.4418C108.75 40.025 110.844 42.1208 113.432 42.1208C116.018 42.1208 118.112 40.025 118.112 37.4418V30.0313H143.856V37.4418C143.856 40.025 145.949 42.1208 148.534 42.1208C151.121 42.1208 153.217 40.025 153.217 37.4418V30.0313H173.107C175.683 30.0313 177.785 32.1313 177.785 34.7116V67.1294L182.692 62.225L191.827 53.0888V34.7121C191.827 24.3912 183.43 15.9926 173.107 15.9926H153.217V4.68224C153.217 2.09765 151.121 0 148.534 0C145.951 0 143.856 2.09481 143.856 4.68224V15.9926H118.107V4.68224C118.107 2.09765 116.012 0 113.426 0C110.838 0 108.744 2.09481 108.744 4.68224V15.9926H85.3437V4.68224C85.3437 2.09765 83.2494 0 80.6615 0C78.0755 0 75.9812 2.09481 75.9812 4.68224V15.9926H49.0715V4.68224C49.0715 2.09765 46.9767 0 44.3907 0C41.8033 0 39.7089 2.09481 39.7089 4.68224V15.9926H22.16C11.8387 15.9926 3.43768 24.3912 3.43768 34.7121V231.28C3.43768 241.603 11.8391 250 22.16 250H173.096C183.419 250 191.816 241.603 191.816 231.28V163.131L177.774 177.176V231.283H177.776V231.283ZM141.218 72.066H49.6497C47.2802 72.066 45.3575 73.9859 45.3575 76.3582C45.3575 78.731 47.2798 80.6504 49.6497 80.6504H141.218C143.588 80.6504 145.51 78.7305 145.51 76.3582C145.51 73.9859 143.588 72.066 141.218 72.066ZM141.218 106.672H49.6497C47.2802 106.672 45.3575 108.593 45.3575 110.964C45.3575 113.337 47.2798 115.256 49.6497 115.256H141.218C143.588 115.256 145.51 113.336 145.51 110.964C145.51 108.593 143.588 106.672 141.218 106.672Z"
            fill="currentColor"
          />
        </svg>
        <span>Create Order</span>
      </div>
    </router-link>
    <router-link to="/orders" class="link">
      <div class="link-wrapper" @click="reloadOrders">
        <StateCountBadges :region="'navigation'" />
        <svg width="250" height="250" viewBox="0 0 250 250" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M36.6211 0C16.4292 0 0 16.4292 0 36.6211C0 56.813 16.4292 73.2422 36.6211 73.2422C56.813 73.2422 73.2422 56.813 73.2422 36.6211C73.2422 16.4292 56.813 0 36.6211 0Z"
            fill="currentColor"
          />
          <path
            d="M36.6211 88.3789C16.4292 88.3789 0 104.808 0 125C0 145.192 16.4292 161.621 36.6211 161.621C56.813 161.621 73.2422 145.192 73.2422 125C73.2422 104.808 56.813 88.3789 36.6211 88.3789Z"
            fill="currentColor"
          />
          <path
            d="M36.6211 176.758C16.4292 176.758 0 193.187 0 213.379C0 233.571 15.9409 250 36.1328 250C56.3247 250 73.2422 233.571 73.2422 213.379C73.2422 193.187 56.813 176.758 36.6211 176.758Z"
            fill="currentColor"
          />
          <path
            d="M228.027 14.6484H110.84C98.7236 14.6484 88.8672 24.5049 88.8672 36.6211C88.8672 48.7373 98.7236 58.5938 110.84 58.5938H228.027C240.144 58.5938 250 48.7373 250 36.6211C250 24.5049 240.144 14.6484 228.027 14.6484Z"
            fill="currentColor"
          />
          <path
            d="M228.027 103.027H110.84C98.7236 103.027 88.8672 112.884 88.8672 125C88.8672 137.116 98.7236 146.973 110.84 146.973H228.027C240.144 146.973 250 137.116 250 125C250 112.884 240.144 103.027 228.027 103.027Z"
            fill="currentColor"
          />
          <path
            d="M228.027 191.406H110.84C98.7236 191.406 88.8672 201.263 88.8672 213.379C88.8672 225.495 98.7236 235.352 110.84 235.352H228.027C240.144 235.352 250 225.495 250 213.379C250 201.263 240.144 191.406 228.027 191.406Z"
            fill="currentColor"
          />
        </svg>

        <span>Orders</span>
      </div>
    </router-link>
    <router-link to="/order-calendar" class="link" v-if="isDashboardAdmin">
      <div class="link-wrapper">
        <svg width="250" height="250" viewBox="0 0 250 250" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_751_36)">
            <path
              d="M31.2502 39.0633V7.81255C31.2502 3.49383 34.744 0 39.0637 0C43.3814 0 46.8753 3.49383 46.8753 7.81255V39.0633C46.8753 43.3809 43.3814 46.8748 39.0637 46.8748C34.744 46.8753 31.2502 43.3809 31.2502 39.0633V39.0633ZM164.064 46.8753C168.381 46.8753 171.877 43.3815 171.877 39.0638V7.81255C171.877 3.49383 168.381 0 164.064 0C159.745 0 156.249 3.49383 156.249 7.81255V39.0633C156.249 43.3809 159.745 46.8753 164.064 46.8753ZM249.999 187.498C249.999 222.017 222.016 250 187.5 250C152.986 250 125 222.017 125 187.498C125 152.984 152.985 125 187.5 125C222.016 125 249.999 152.984 249.999 187.498ZM234.376 187.498C234.376 161.653 213.35 140.624 187.5 140.624C161.653 140.624 140.626 161.653 140.626 187.498C140.626 213.348 161.653 234.374 187.5 234.374C213.35 234.374 234.376 213.348 234.376 187.498ZM62.5009 93.7501H31.2502V125H62.5009V93.7501ZM31.2502 171.875H62.5009V140.624H31.2502V171.875ZM78.1249 125H109.376V93.7501H78.1249V125ZM78.1249 171.875H109.376V140.624H78.1249V171.875ZM15.6261 185.945V78.1245H187.5V109.375H203.126V48.4323C203.126 38.9411 195.556 31.2497 186.204 31.2497H179.688V39.0638C179.688 47.6688 172.682 54.6884 164.065 54.6884C155.444 54.6884 148.439 47.6688 148.439 39.0638V31.2497H54.6873V39.0638C54.6873 47.6688 47.6837 54.6884 39.0643 54.6884C30.4428 54.6884 23.4386 47.6688 23.4386 39.0638V31.2497H16.9302C7.57757 31.2497 0.000488281 38.9411 0.000488281 48.4323V185.945C0.000488281 195.405 7.57757 203.126 16.9302 203.126H109.376V187.499H16.9302C16.2222 187.498 15.6261 186.767 15.6261 185.945V185.945ZM156.249 125V93.7501H125.001V125H156.249ZM210.938 187.498H187.5V164.06C187.5 159.744 184.006 156.25 179.687 156.25C175.368 156.25 171.877 159.744 171.877 164.06V195.313C171.877 199.63 175.368 203.126 179.687 203.126H210.938C215.256 203.126 218.75 199.63 218.75 195.313C218.75 190.994 215.256 187.498 210.938 187.498Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_751_36">
              <rect width="250" height="250" fill="white" />
            </clipPath>
          </defs>
        </svg>

        <span>Calendar</span>
      </div>
    </router-link>
    <router-link to="/lab-packages" class="link" v-if="isAdmin">
      <div class="link-wrapper">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M7 19C5.9 19 5 19.9 5 21H19C19 19.9 18.1 19 17 19H13V17H16C17.1 17 18 16.1 18 15H10C8.34 15 7 13.66 7 12C7 10.91 7.59 9.96 8.46 9.44C8.17 9.03 8 8.54 8 8C8 7.79 8.04 7.58 8.09 7.38C6.28 8.13 5 9.92 5 12C5 14.76 7.24 17 10 17V19H7Z"
            fill="black"
          />
          <path
            d="M10.56 5.51C11.91 5.54 13 6.64 13 8C13 8.75 12.67 9.41 12.15 9.87L12.74 11.49L13.68 11.15L14.02 12.09L15.9 11.41L15.56 10.47L16.5 10.13L13.76 2.6L12.82 2.94L12.48 2L10.6 2.68L10.94 3.62L10 3.97L10.56 5.51Z"
            fill="black"
          />
          <path
            d="M10.5 9.5C11.3284 9.5 12 8.82843 12 8C12 7.17157 11.3284 6.5 10.5 6.5C9.67157 6.5 9 7.17157 9 8C9 8.82843 9.67157 9.5 10.5 9.5Z"
            fill="black"
          />
        </svg>

        <span>Lab Packages</span>
      </div>
    </router-link>
    <router-link to="/manage-users" class="link" v-if="isAdmin">
      <div class="link-wrapper">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M16 11C17.66 11 18.99 9.66 18.99 8C18.99 6.34 17.66 5 16 5C14.34 5 13 6.34 13 8C13 9.66 14.34 11 16 11ZM8 11C9.66 11 10.99 9.66 10.99 8C10.99 6.34 9.66 5 8 5C6.34 5 5 6.34 5 8C5 9.66 6.34 11 8 11ZM8 13C5.67 13 1 14.17 1 16.5V19H15V16.5C15 14.17 10.33 13 8 13ZM16 13C15.71 13 15.38 13.02 15.03 13.05C16.19 13.89 17 15.02 17 16.5V19H23V16.5C23 14.17 18.33 13 16 13Z"
            fill="black"
          />
        </svg>

        <span>Manage Users</span>
      </div>
    </router-link>
    <router-link to="/settings" class="link" v-if="isAdmin">
      <div class="link-wrapper">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M19.14 12.94C19.18 12.64 19.2 12.33 19.2 12C19.2 11.68 19.18 11.36 19.13 11.06L21.16 9.47999C21.34 9.33999 21.39 9.06999 21.28 8.86999L19.36 5.54999C19.24 5.32999 18.99 5.25999 18.77 5.32999L16.38 6.28999C15.88 5.90999 15.35 5.58999 14.76 5.34999L14.4 2.80999C14.36 2.56999 14.16 2.39999 13.92 2.39999H10.08C9.83999 2.39999 9.64999 2.56999 9.60999 2.80999L9.24999 5.34999C8.65999 5.58999 8.11999 5.91999 7.62999 6.28999L5.23999 5.32999C5.01999 5.24999 4.76999 5.32999 4.64999 5.54999L2.73999 8.86999C2.61999 9.07999 2.65999 9.33999 2.85999 9.47999L4.88999 11.06C4.83999 11.36 4.79999 11.69 4.79999 12C4.79999 12.31 4.81999 12.64 4.86999 12.94L2.83999 14.52C2.65999 14.66 2.60999 14.93 2.71999 15.13L4.63999 18.45C4.75999 18.67 5.00999 18.74 5.22999 18.67L7.61999 17.71C8.11999 18.09 8.64999 18.41 9.23999 18.65L9.59999 21.19C9.64999 21.43 9.83999 21.6 10.08 21.6H13.92C14.16 21.6 14.36 21.43 14.39 21.19L14.75 18.65C15.34 18.41 15.88 18.09 16.37 17.71L18.76 18.67C18.98 18.75 19.23 18.67 19.35 18.45L21.27 15.13C21.39 14.91 21.34 14.66 21.15 14.52L19.14 12.94ZM12 15.6C10.02 15.6 8.39999 13.98 8.39999 12C8.39999 10.02 10.02 8.39999 12 8.39999C13.98 8.39999 15.6 10.02 15.6 12C15.6 13.98 13.98 15.6 12 15.6Z"
            fill="black"
          />
        </svg>

        <span>Settings</span>
      </div>
    </router-link>
    <router-link to="/user" class="link last">
      <div class="link-wrapper">
        <svg width="250" height="250" viewBox="0 0 250 250" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
          <g clip-path="url(#clip0_751_100)">
            <path
              d="M125 132.386C155.956 132.386 181.054 103.013 181.054 66.7785C181.054 16.5317 155.957 1.17114 125 1.17114C94.0424 1.17114 68.9474 16.5317 68.9474 66.7785C68.948 103.013 94.043 132.386 125 132.386V132.386Z"
              fill="currentColor"
            />
            <path
              d="M248.777 228.952L220.498 165.248C219.204 162.333 216.932 159.915 214.104 158.442L170.216 135.596C169.248 135.093 168.076 135.191 167.206 135.85C154.793 145.238 140.198 150.201 125 150.201C109.801 150.201 95.2069 145.238 82.7939 135.85C81.9214 135.191 80.7495 135.093 79.7816 135.596L35.8966 158.442C33.067 159.915 30.7972 162.331 29.5025 165.248L1.22297 228.952C-0.726727 233.344 -0.327133 238.369 2.29222 242.397C4.91035 246.425 9.34132 248.829 14.1456 248.829H235.854C240.658 248.829 245.09 246.424 247.708 242.397C250.326 238.369 250.727 233.342 248.777 228.952Z"
              fill="currentColor"
            />
          </g>
          <defs>
            <clipPath id="clip0_751_100">
              <rect width="250" height="250" fill="white" />
            </clipPath>
          </defs>
        </svg>
        <span>My User</span>
      </div>
    </router-link>
    <a href="https://lab.webaruba.com/contact" target="_blank" class="link contact-link last" v-if="isClient">
      <div class="link-wrapper">
        <span class="glyphicon glyphicon-earphone mr-2"></span>
        <span>Contact</span>
      </div>
    </a>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';

import StateCountBadges from './StateCountBadges.vue';

export default {
  name: 'navigation',
  components: {
    StateCountBadges
  },
  computed: {
    ...mapGetters({
      ordersMade: 'ordersMade',
      isDashboardAdmin: 'isDashboardAdmin',
      isAdmin: 'isAdmin',
      isClient: 'isClient',
      ordersStateCount: 'ordersStateCount',
      userData: 'userData',
      ordersMadeSelectedData: 'ordersMadeSelectedData'
    })
  },
  methods: {
    ...mapActions({
      unselectOrderMade: 'unselectOrderMade',
      getOrdersStatesCount: 'getOrdersStatesCount'
    }),
    reloadOrders() {
      if (!this.ordersMadeSelectedData.selectedFromCalendar) this.unselectOrderMade();
    },
    reloadOrdersUser() {
      if (!this.ordersMadeSelectedData.selectedFromCalendar) this.unselectOrderMade();
    }
  }
};
</script>

<style lang="scss"></style>
